/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFireExtinguisherIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-fire-extinguisher"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.2 16.88L6.2 13.78L17.8 13.78L17.8 16.88ZM12 5.35Q12.43 5.35 12.71 5.05Q13 4.75 13 4.33Q13 3.92 12.7 3.64Q12.4 3.35 12 3.35Q11.57 3.35 11.29 3.64Q11 3.92 11 4.33Q11 4.75 11.29 5.05Q11.57 5.35 12 5.35ZM6.35 11.78Q6.75 10.4 7.75 9.18Q8.75 7.95 10.1 7.47Q9.68 7.2 9.31 6.83Q8.95 6.45 8.72 5.97L5.25 5.25Q4.97 5.2 4.83 4.99Q4.67 4.78 4.67 4.5L4.67 4.2Q4.67 3.92 4.83 3.71Q4.97 3.5 5.25 3.45L8.72 2.73Q9.15 1.82 10.03 1.26Q10.9 0.7 12 0.7Q12.65 0.7 13.25 0.93Q13.85 1.15 14.32 1.55L16.73 1.05Q17.35 0.93 17.84 1.31Q18.32 1.7 18.32 2.35L18.32 6.35Q18.32 7 17.84 7.39Q17.35 7.78 16.73 7.65L14.32 7.15Q14.2 7.25 14.1 7.33Q14 7.4 13.88 7.47Q15.22 7.92 16.25 9.16Q17.27 10.4 17.68 11.78ZM8.85 22.8Q7.75 22.8 6.97 22.02Q6.2 21.25 6.2 20.15L6.2 18.77L17.8 18.77L17.8 20.15Q17.8 21.25 17.02 22.02Q16.25 22.8 15.15 22.8Z" fill={color} />
    </svg>
  );
}
